import React from 'react';
import './ActivityFeed.css';

function ActivityFeed({ recentActivities }) {
    return (
        <div className="dp-activity-card dp-neumorphic">
            <h2 className="dp-section-title">Actividades Recientes</h2>
            <div className="dp-activity-list">
                {recentActivities && recentActivities.length > 0 ? (
                    recentActivities.map(activity => (
                        <div className="dp-activity-item dp-neumorphic-flat" key={activity.id}>
                            <div className="dp-activity-info">
                                <div className="dp-activity-icon">🎮</div>
                                <div className="dp-activity-details">
                                    <div className="dp-activity-title">{activity.activity_type}</div>
                                    <div className="dp-activity-date">{activity.completed_at}</div>
                                </div>
                            </div>
                            <div className="dp-activity-score">+{activity.xp_gained}</div>
                        </div>
                    ))
                ) : (
                    <p>Completa un ejercicio para ver tu actividad.</p>
                )}
            </div>
        </div>
    );
}

export default ActivityFeed;